import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { AsmMainUiComponent } from '@spartacus/asm/components';
import { SikoSsoSignOnService } from '@siko/common';

@Component({
   selector: 'cx-asm-main-ui',
   templateUrl: './asm-main-ui.component.html',
   changeDetection: ChangeDetectionStrategy.OnPush,
   standalone: false,
})
export class SikoAsmMainUiComponent extends AsmMainUiComponent implements OnInit {
   private readonly ssoSignOn: SikoSsoSignOnService = inject(SikoSsoSignOnService);

   ngOnInit(): void {
      super.ngOnInit();
      this.ssoSignOn.handleRedirectCallback();
   }

   signInWithSSO = (): Promise<void> => this.ssoSignOn.signInWithSSO();

   logout(): void {
      super.logout();

      if (this.ssoSignOn.isSsoSession()) {
         this.ssoSignOn.logoutSSO();
      }
   }
}
